<template>
    <section id="campanie" class="teaser">
        <div class="container">
            <h1 data-aos="fade-up" data-aos-duration="2000" data-aos-delay="50" class="section__title">Campania s-a încheiat!</h1>
            <h6 data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100" class="teaser__text">
                Îți mulțumim, poți citi regulamentul campaniei aici: <br>
                <strong><a href="/docs/Regulament-Campanie-Distractie-in-Familie-cu-Pufina_autentificat.pdf" target="_blank" rel="noopener noreferer">Regulamentul campaniei - Distracție în familie cu Pufina</a></strong><br>
                <br>
                Vezi <strong><a href="/docs/lista-castigatori-distractie-in-familie-cu-Pufina.pdf" target="_blank" rel="noopener noreferer">lista câștigătorilor</a></strong>
            </h6>
        </div>
    </section>
</template>

<script>
export default {

}
</script>